/**
 * Created by fuzhengsong on 2017/9/19.
 */
export default {
  restfullMock: false,        // 是否开启接口本地Mock
  mockConfig: {
    timeout: '1000-200'
  },
  restfull: '/test!',
  ns: 'api',
  wxsdk: '//res.wx.qq.com/open/js/jweixin-1.2.0.js',
  mta: {},
  // 是否启用cdn功能
  cdnPrefix: '!',
  cdn: {
    'cdn.sc.dev.milake.cn': null
  },
  cdnRename: {},
  base: __dirname,
  ravenJs: '',
  serverUrl: '',
  // 百度文档预览配置
  baidu_doc: {
    preview_url: '//static.bcedocument.com/reader/v2/doc_reader_v2.js'
  }
};

export const defaultImage = {
  // todo 替换cdn上的连接
  avatar: require('../../html/image/avatar.png'),
  studentAvatar: require('../../html/image/student.png'),
  cover: require('../../html/image/cover.jpg'),
  cover1: require('../../html/image/pic1.jpg')
};

export const allowMimeType = [
	'jpe,jpg,jpeg,png,bmp,gif',
	'txt',
	'ppt,pptx,wps,pps,pdf',
	'mp3',
	'mpeg,ogg,mp4',
	'xlsx,xls',
	'doc,docx',
	'zip,rar',
	'dwg'
];

